import React from "react";
import Header from "../components/Header.js";
import HeroSection from "../components/HeroSection.jsx";
import CategorySection from "../components/CategorySection.jsx";
import AboutSection from "../components/AboutSection.jsx";
import HowItWorks from "../components/HowItWorks.jsx";
import LocationSection from "../components/LocationSection.jsx";
import Footer from "../components/Footer.js";

export default function Home() {
  return (
    <div className="bg-white text-gray-800 font-sans antialiased">
      {/* Header */}
      <Header />

      {/* Hero Section */}
      <HeroSection />

      {/* Categories Section - Orange Design */}

      <CategorySection />

      {/* About Section */}
      <AboutSection />

      {/* How It Works Section */}
      <HowItWorks />

      {/* Locations Section */}
      <LocationSection />

      {/* Footer */}
      <Footer />

    </div>
  );
}
